import ColumnUtils from '../ColumnUtils';

const min = Math.min;
const max = Math.max;
const floor = Math.floor;
const ceil = Math.ceil;

function getGridState(props) {
  const totalNumberColumns = ColumnUtils.getSize(props.columnMetrics.columns);
  const canvasHeight = props.minHeight - props.rowOffsetHeight;
  const renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
  const totalRowCount = props.disableVirtualRows ? props.rowsCount + 1 : min(renderedRowsCount * 4, props.rowsCount);
  return {
    displayStart: 0,
    displayEnd: totalRowCount,
    visibleStart: 0,
    visibleEnd: totalRowCount,
    height: canvasHeight,
    scrollTop: 0,
    scrollLeft: 0,
    colVisibleStart: 0,
    colVisibleEnd: totalNumberColumns,
    colDisplayStart: 0,
    colDisplayEnd: totalNumberColumns,
  };
}

function getVisibleColStart({ columnMetrics }, scrollLeft) {
  let remainingScroll = scrollLeft;
  let columnIndex = -1;
  while (remainingScroll >= 0) {
    columnIndex++;
    remainingScroll -= ColumnUtils.getColumn(columnMetrics.columns, columnIndex).width;
  }
  return columnIndex;
}

function getNextScrollState(
  { columnMetrics, disableVirtualRows, overScan },
  getDOMNodeOffsetWidth,
  scrollTop,
  scrollLeft,
  height,
  rowHeight,
  length,
  width
) {
  const isScrolling = true;
  const renderedRowsCount = ceil(height / rowHeight);
  const visibleStart = disableVirtualRows ? 0 : max(0, floor(scrollTop / rowHeight));
  const visibleEnd = disableVirtualRows ? length + 1 : min(visibleStart + renderedRowsCount, length);
  const displayStart = disableVirtualRows ? 0 : max(0, visibleStart - overScan.rowsStart);
  const displayEnd = disableVirtualRows ? length + 1 : min(visibleEnd + overScan.rowsEnd, length);
  const totalNumberColumns = ColumnUtils.getSize(columnMetrics.columns);
  const colVisibleStart = totalNumberColumns > 0 ? max(0, getVisibleColStart({ columnMetrics }, scrollLeft)) : 0;
  const renderedColumnCount = columnMetrics.columns.length;
  const colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
  const colDisplayStart = max(0, colVisibleStart - overScan.colsStart);
  const colDisplayEnd = min(colVisibleEnd + overScan.colsEnd, totalNumberColumns);

  const nextScrollState = {
    visibleStart,
    visibleEnd,
    displayStart,
    displayEnd,
    height,
    scrollTop,
    scrollLeft,
    colVisibleStart,
    colVisibleEnd,
    colDisplayStart,
    colDisplayEnd,
    isScrolling,
  };

  return nextScrollState;
}

export { getGridState, getNextScrollState };
